const getStockReportFields = async (mainApi, serviceId) => {
  const reportFields = await mainApi.service.listReportFields(serviceId)
  const exportHeaders = reportFields.map((field) => ({
    label: field.name,
    value: field.id
  }))

  return [
    { label: 'productId', value: 'productId' },
    { label: 'productName', value: 'productName' },
    ...exportHeaders
  ]
}

module.exports = {
  getStockReportFields
}
